// extracted by mini-css-extract-plugin
export default {"header":"index_header__JG28x","title":"index_title__-4ITr","head":"index_head__+b+o5"};